<template>
    <div>
        <textarea type="text" v-model="localValue" id="summernote_div" ref="summernote"/>  
    </div>
  </template>
  
<script>

import 'jquery';
import 'summernote/dist/summernote-bs4.css';
import 'popper.js';
import 'bootstrap';
import 'summernote/dist/summernote-bs4.js';


export default {
    name: 'SummernoteEditor',
    props: {
      value: {},
    },
    data() {
        return {
            localValue: '',
            changed: 0,
        }
    },
    watch: {
      value(newVal, oldVal) {
        if(this.changed === 0) {
            this.$emit('input', newVal)
            this.setValue(newVal)
        }
      },
    },
    mounted() {
        $(this.$refs.summernote).summernote({
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['table', ['table']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link']]
            ],      
            minHeight: 200, // set minimum height of editor
            maxHeight: null, // set maximum height of editor
            focus:true,
            callbacks: {
                onChange: (contents, $editable) => {
                    this.changed++
                    this.$emit('input', contents)
                }
            }
        })
    },
    beforeDestroy() {
        $(this.$refs.summernote).summernote('destroy');
    },
    methods: {
      setValue(val) {
        $(this.$refs.summernote).summernote('code', val);
      }
    },

};
</script>

<style>

.note-editable {
    font-family: none !important;
}
/* Add any additional styling if needed */
</style>